(function () {
  function openShippingModal() {
    document.dispatchEvent(new CustomEvent('gebest:shipping-modal:open'));
  }

  function initShippingModal() {
    if (!document.querySelector('[data-shipping-modal]')) return;

    document.addEventListener('click', (event) => {
      const trustList = event.target.closest('.product-gebest__trust-list');
      if (!trustList) return;

      event.preventDefault();
      openShippingModal();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShippingModal);
  } else {
    initShippingModal();
  }
})();
